import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyCzyHDDrx4rgHuq9dIWC0EKFDXrCLK7tWY",
    authDomain: "gifttocash-570a7.firebaseapp.com",
    projectId: "gifttocash-570a7",
    storageBucket: "gifttocash-570a7.firebasestorage.app",
    messagingSenderId: "411480629193",
    appId: "1:411480629193:web:c8c55087576910e4d6d218"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

const VAPID_KEY = "BA2Pbly0_EUboC77XKQOWzg9B7XjBYJcN8ky4vx8XOIdGI-iZaFLKrEv3jJvd9w4ZupCXB2jytFZLLcRqP4_4g0";

export async function requestPushPermission() {
    try {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") return null;
        const token = await getToken(messaging, { vapidKey: VAPID_KEY });
        return token;
    } catch (err) {
        console.error("Push permission error:", err);
        return null;
    }
}

export { messaging, onMessage };